<template>
  <div class="dataroom">
    <h2 class="bold mb-3">{{$t("Importer un nouveau fichier")}} <small><a href="/docs/modele_dataroom.xlsx">{{$t("télécharger un modèle de fichier")}}</a></small></h2>
    <div v-if="importDone || importData.messageError || importData.messageSuccess" class="bg-blue mb-4">
      <p v-if="importData.messageError!=''" class="text-danger">{{importData.messageError}}</p>
      <p v-if="importData.messageSuccess!=''" class="text-success">{{importData.messageSuccess}}</p>
      <table class="table dtt" v-if="importDone && importData.dataError && importData.dataError.length>0">
        <thead>
          <tr>
            <th v-for="(head,hid) in importData.modele" :key="'hid_'+hid">{{$t(head.libelle)}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tr,trid) in importData.dataError" :key="'trid_'+trid">
            <td v-for="(td,tdid) in tr" :key="'tdid_'+tdid">
              <span v-if="tdid=='I'"></span>
              <b-form-select :class="'form-control '+getClass(trid,tdid)" :options="options_type_bien" v-model='importData.dataError[trid][tdid]' v-else-if="importData.modele[tdid].type=='type_bien'" :required="importData.modele[tdid].required">
                <template #first v-if="!options_type_bien.some(e => e.value == importData.dataError[trid][tdid])">
                  <b-form-select-option :value="importData.dataError[trid][tdid]" disabled>{{ importData.dataError[trid][tdid] }}</b-form-select-option>
                </template>
              </b-form-select>
              <autocomplete v-else-if="importData.modele[tdid].type=='adresse'" :initialValue="importData.dataError[trid][tdid]" :initialDisplay="importData.dataError[trid][tdid]" :placeholder="$t('Adresse')" :source="getDataAddress" :input-class="'form-control'+getClass(trid,tdid)" results-property="data" :resultsFormatter="resultDataAddress" :results-display="formattedDataAddress" :required="importData.modele[tdid].required" @selected="getAddressData($event,importData.dataError[trid])" :delay="500"></autocomplete>
              <b-form-input :class="'form-control '+getClass(trid,tdid)" :formatter="formatNumber" v-else-if="importData.modele[tdid].type=='superficie'" v-model='importData.dataError[trid][tdid]' :required="importData.modele[tdid].required"></b-form-input>
              <b-form-input :class="'form-control '+getClass(trid,tdid)" v-else v-model='importData.dataError[trid][tdid]' :required="importData.modele[tdid].required"></b-form-input>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-if="importData.dataError && importData.dataError.length>0">
        <button type="button" class="btn btn-secondary btn-sm mr-2" @click="annuler">{{$t("Annuler")}}</button>
        <button type="button" class="btn btn-secondary btn-sm mr-2" @click="close">{{$t("Continuer plus tard")}}</button>
        <button type="button" class="btn btn-primary btn-sm" @click="enregistrer">{{$t("Valider ma saisie")}}</button>
      </p>
    </div>
    <vue-dropzone v-if="!importDone && can_upload_dataroom" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" class="mb-4" :useCustomSlot=true @vdropzone-complete="afterComplete" @vdropzone-error="fileError">
      <div class="dropzone-custom-content">
        <h1 class="dropzone-custom-title bold">{{$t("Glissez-déposez un fichier ici")}}</h1>
        <p class="text-center"><a href="javascript:void(0)" class="hight">{{$t("ou cliquez pour importer un fichier")}}</a></p>
        <div class="subtitle"><small>{{$t("Importer des demandes à partir d'un fichier CSV; XLS ou XLSX. L'import est limité à 25MO.")}}</small></div>
      </div>
    </vue-dropzone>
    <Liste ref="liste" @continuer="continuer" />
  </div>
</template>

<script>
  import axios from "axios";
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import Liste from '@/components/Liste'
  export default {
    name: "dataroom",
    components: {
      Liste,
      vueDropzone: vue2Dropzone
    },
    data () {
        return {
          dropzoneOptions: {
              url: '#',
              method: 'post',
              thumbnailWidth: 150,
              maxFilesize: 25,
              acceptedFiles: '.xls,.csv,.xlsx',
              dictInvalidFileType: this.$i18n.t("Ce type de fichier n'est pas autorisé"),
              renameFile : function (file) {
                let tmpName = file.name.split('.');
                tmpName = tmpName[0].replace(/[\W_-]/g,'') + '.' + tmpName[1];
                return tmpName;
              }
          },
          can_upload_dataroom:(localStorage.getItem('can_upload_dataroom')?localStorage.getItem('can_upload_dataroom'):false),
          importDone:false,
          importData:{},
          importDataCopie:{},
          options_type_bien: [
              { value: "Appartement", html: this.$i18n.t("Appartement")},
              { value: "Maison", html: this.$i18n.t("Maison")},
          ],
        }
    },
    methods: {
      fileError(file, message, xhr) {
        this.importData={messageError:message};
        this.$refs.myVueDropzone.removeAllFiles();
      },
      afterComplete(file) {
        if(file.xhr){
          this.importDone=true;
          this.importData=JSON.parse(file.xhr.response);
          this.importDataCopie=JSON.parse(file.xhr.response);
          this.$refs.myVueDropzone.removeAllFiles();
          this.$refs.liste.get_data(1);
        }
      },
      continuer(id){
        var p = this;
        axios.get(p.$apiUrl+"dataroom/submit/"+id+"?lang="+p.$i18n.locale+"&auth="+JSON.stringify(p.auth_header())).then(function(response){
            if(response.data.error=='notlogged'){
                p.logout();
                p.$router.push({ path: '/' });
            }
            else{
              p.importDone=true;
              p.importData=JSON.parse(JSON.stringify(response.data));
              p.importDataCopie=JSON.parse(JSON.stringify(response.data));
              window.scrollTo(0,0);
            }
        }).catch(function(error){
        });
      },
      annuler(){
        if(window.confirm(this.$i18n.t("Êtes-vous sur de vouloir annuler ?"))){
          this.importDone=false;
          this.importData={};
          var p = this;
          axios.get(p.$apiUrl+"dataroom/supprimer/"+p.importData.successId+"?lang="+this.$i18n.locale+"&auth="+JSON.stringify(p.auth_header())).then(function(response){
              if(response.data.error=='notlogged'){
                  p.logout();
                  p.$router.push({ path: '/' });
              }
              else{
                p.$refs.liste.get_data(1);
              }
          }).catch(function(error){
          });
        }
      },
      close(){
        var nbError=0;
        var nbLineError=0;
        for(let tr in this.importData.dataError){
          var nbErrorTmp=0;
          for(let td in this.importData.dataError[tr]){
            if(td!='I' && this.importData.modele[td].required && (!this.importData.dataError[tr][td] || this.importData.dataError[tr][td]=="")){
              nbError++;
              nbErrorTmp++;
            }
          }
          if(nbErrorTmp>0)nbLineError++;
        }
        this.updateDataroom(0);
      },
      formatNumber(value) {
        return value.replace(/[^0-9]/g, '');
      },
      enregistrer(){
        var nbError=0;
        var nbLineError=0;
        for(let tr in this.importData.dataError){
          var nbErrorTmp=0;
          for(let td in this.importData.dataError[tr]){
            if(td!='I' && this.importData.modele[td].required && (!this.importData.dataError[tr][td] || this.importData.dataError[tr][td]=="")){
              nbError++;
              nbErrorTmp++;
            }
          }
          if(nbErrorTmp>0)nbLineError++;
        }
        if(nbError>0){   
          this.$bvModal.msgBoxConfirm(
            (this.$i18n.t("Il vous reste")+" "+nbLineError+" "+this.$i18n.t("ligne"+(nbLineError>1?"s":"")+" en erreur. Si vous continuez avec la valorisation de ce portefeuille, ces lignes ne seront pas prises en compte.")),
            {
              title: this.$i18n.t("Voulez-vous continuer ?"),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              okTitle: 'Oui',
              cancelTitle: '',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true
            }).then(value => {
            if(value)this.updateDataroom(1);
          })
        }else{
          this.updateDataroom(1);
        }
      },
      updateDataroom(now){
        var p=this;
        let formData = new FormData();
        formData.append('datas', JSON.stringify(p.importData));
        axios.post(p.$apiUrl+"dataroom/update?lang="+p.$i18n.locale+"&now="+now+"&auth="+JSON.stringify(p.auth_header()),formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(function(response){
            if(response.data.error=='notlogged'){
                p.logout();
                p.$router.push({ path: '/' });
            }
            else{
              p.importData=response.data;
              p.importDataCopie=response.data;
              p.$refs.liste.get_data(1);
            }
        }).catch(function(error){
        });
      },
      getClass(trid,tdid){
        if(!this.importData.modele[tdid].required)return "";
        else{
          if(this.importData.dataError[trid][tdid] && this.importData.dataError[trid][tdid]!=""){
            if(this.importData.dataError[trid][tdid]!=this.importDataCopie.dataError[trid][tdid])return " success";
            else return "";
          }
          else{
            return " error";
          }
        }
      },
      getDataAddress(obj){if(obj.length<3)return false;return this.$apiUrl+"api_externe/autocomplete?auth="+JSON.stringify(this.auth_header())+"&parameters[calltype]=autocomplete-ban&parameters[token]="+JSON.stringify(this.auth_header()).replace('"Authorization":"Basic ','')+"&parameters[address]="+obj+"&parameters[country]=FR";},
      resultDataAddress(response) {return response.datas;},
      formattedDataAddress(result) {if(result)return result.address;},
      getAddressData(group,f) {
          f.D = group.selectedObject.address;
          if(group.selectedObject.id!=null && group.selectedObject.id!=""){
              axios.get(this.$apiUrl+"api_externe/autocomplete?auth="+JSON.stringify(this.auth_header())+"&parameters[calltype]=place&parameters[token]="+JSON.stringify(this.auth_header()).replace('"Authorization":"Basic ','')+"&parameters[placeID]="+group.selectedObject.id).then(response => {
                  f.E = response.data.datas[0].number+' '+response.data.datas[0].repetition;
                  f.F = response.data.datas[0].street;
                  f.G = response.data.datas[0].zipcode;
                  f.H = response.data.datas[0].city;
              }).catch(error => {});
          }else{
              f.E = group.selectedObject.number+' '+group.selectedObject.repetition;
              f.F = group.selectedObject.street;
              f.G = group.selectedObject.zipcode;
              f.H = group.selectedObject.city;
          }
      },
    },
    mounted () {
      axios.get(this.$apiUrl+"params/right/dataroom/u?auth="+JSON.stringify(this.auth_header())).then(response => {
        this.can_upload_dataroom=response.data;
        localStorage.setItem('can_upload_dataroom',(this.can_upload_dataroom));
      })
      this.dropzoneOptions.url=this.$apiUrl+"dataroom/submit/0?auth="+JSON.stringify(this.auth_header());
      this.$refs.myVueDropzone.setOption('url',this.dropzoneOptions.url)
    }
  };
</script>
